var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://feelline.jp/","target":"_blank"}},[_vm._v("FEELLINE")]),_c('span',{staticClass:"ml-1"},[_vm._v("Copyright © A.T.WORKS, Inc. All Rights Reserved.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }